import { Map as ImmutableMap } from 'immutable';
import { createSelector } from 'reselect';

import type { ReportConfiguration } from 'app-components/flux/report-configurations/reportConfigurationsTypes';
import type RootState from 'app-components/utils/redux-store/rootState';

import { REPORT_CONFIGURATION_DEFAULTS_REDUCER_KEY } from './reportConfigurationDefaultsTypes';

type State = Pick<RootState, typeof REPORT_CONFIGURATION_DEFAULTS_REDUCER_KEY>;

export const getReportConfigurationDefaultsStore = (state: State) => state[REPORT_CONFIGURATION_DEFAULTS_REDUCER_KEY];

export const getIsLoading = createSelector(getReportConfigurationDefaultsStore, (store) => store.isLoading);
export const getLoadPending = createSelector(getReportConfigurationDefaultsStore, (store) => store.loadPending);
export const getError = createSelector(getReportConfigurationDefaultsStore, (store) => store.error);
export const getLastSyncDate = createSelector(getReportConfigurationDefaultsStore, (store) => store.lastSyncDate);
export const getResourcesById = createSelector(getReportConfigurationDefaultsStore, (store) => store.resourcesById);

export const getReportsConfigurationsByName = createSelector(getResourcesById, (reportConfigurationsById) =>
  reportConfigurationsById.reduce(
    (result, reportConfiguration) => result.set(reportConfiguration.name, reportConfiguration),
    ImmutableMap<string, ReportConfiguration>(),
  ),
);

export const getReportConfigByName = createSelector(
  getReportsConfigurationsByName,
  (_state: unknown, props: { name: string }) => props.name,
  (reportConfigurationsByName, name) => reportConfigurationsByName.get(name),
);
